function startLoader() {
  const fill = document.getElementById("progressFill");
  const percentText = document.getElementById("progressPercent");

  let percent = 0;
  let interval = setInterval(() => {
    if (percent < 100) {
      percent++;
      fill.style.width = percent + "%";
      percentText.textContent = percent + "%";
    }

    if (percent === 100) {
      clearInterval(interval);
      setTimeout(() => {
        window.location.href = "/pages/result";
      }, 500);
    }
  }, 40);
}
